import React, { Component } from 'react';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation/Navigation';
import Footer from '../../components/Footer/Footer';
import Spacer from '../../components/Spacer';
import Home from '../../views/Home/Home';
import HeadingPage from '../../views/HeadingPage';
import Why from '../../views/Why';
import WhatIDo from '../../views/WhatIDo';
import Work from '../../views/Work/Work';
import Contact from '../../views/Contact';
import Josh from '../../views/Josh';
import animations from './animations';
import PageLoader from "../../components/PageLoader";
import RandomParent from "../../components/RandomParent";
import { Helmet } from "react-helmet";
import { isMobile } from "react-device-detect";

class App extends Component {

	constructor(props) {
		super(props);

		this.state = {
			favIcon: '/favicon.ico'
		};
	}


	componentDidMount() {
        animations.initialise();
        this.refreshOnScreenChange();
    }

    handleChangeLights() {
    	animations.resetWhatIDo();
	}

	handleChangeFavIcon(green) {
		this.setState({
			favIcon: green ? '/favicon-green.ico' : '/favicon.ico'
		});
	}

    getPauseAnimation(animation) {
        this.pauseAnimation = animation;
    }

    getMergeAnimation(animation) {
    	this.mergeAnimation = animation;
	}

	getUnMergeAnimation(animation) {
		this.unMergeAnimation = animation;
	}

    pauseHomeTl() {
		this.pauseAnimation();
    }

    mergeHomeTl() {
    	this.mergeAnimation();
	}

	unMergeHomeTl() {
    	this.unMergeAnimation();
	}

	refreshOnScreenChange() {
		let resizeTimer,
			originalWidth = window.innerWidth,
			originalHeight = window.innerHeight;

		window.onresize = () => {
			clearTimeout(resizeTimer);

			if (this.widthChanged(originalWidth) || this.heightChanged(originalHeight)) {
				resizeTimer = setTimeout(() => {
					window.location.reload(true);
				}, 500);
			}
		};
	}

	widthChanged(originalWidth) {
		return originalWidth !== window.innerWidth && ((originalWidth - window.innerWidth) > 100 || (originalWidth - window.innerWidth) < -100);
	}

	heightChanged(originalHeight) {
		return originalHeight !== window.innerHeight && ((originalHeight - window.innerHeight) > 100 || (originalHeight - window.innerHeight) < -100);
	}

    render() {
		const Heading1 = isMobile ? `Not your<br />typical engineer` : `Not your typical engineer`;
		const Heading2 = isMobile ? `A man must<br />have a code<br />- The Wire` : `A man must have a code - The Wire`;
		const Heading3 = isMobile ? `Check out the goods` : `Check out the goods`;
		const Heading4 = `Reach out, let's connect`;

        return (
            <div>
				<Helmet>
					<link rel="shortcut icon" href={this.state.favIcon} />
				</Helmet>
				<PageLoader />
                <Header />
                <Navigation pauseHomeTl={this.pauseHomeTl.bind(this)}/>
                <Home
					getPauseAnimation={this.getPauseAnimation.bind(this)}
					getMergeAnimation={this.getMergeAnimation.bind(this)}
					getUnMergeAnimation={this.getUnMergeAnimation.bind(this)}
				/>
                <HeadingPage title={Heading1} id="intro1" />
				{!isMobile ? <Josh id="josh" /> : ''}
                <Why id="why" />
				<Spacer height="25vh" />
                <HeadingPage title={Heading2} id="intro2" />
                <Spacer height="50vh" />
                <WhatIDo id="what-i-do" />
                <Spacer height="375vh" />
                <HeadingPage title={Heading3} id="intro3" />
				<Spacer height="50vh" />
                <Work id="work" />
                <HeadingPage title={Heading4} id="intro4" />
				<Spacer height="50vh" />
                <Contact id="contact" />
                <Footer handleChangeLights={this.handleChangeLights.bind(this)} handleChangeFavIcon={this.handleChangeFavIcon.bind(this)} className="d-none d-lg-block" />
				<RandomParent />
            </div>
        );
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/js/layout/App/App.js